import React, { useState, useEffect, useCallback } from 'react';
import { yonetim } from '../api';
import { ONAY_DURUMU, tarih, tarihSaat } from '../yardimcilar';
import DurumEtiketi from '../components/DurumEtiketi';
import Gorsel from '../components/Gorsel';
import OnayModal from '../components/OnayModal';
import Modal from '../components/Modal';

const SEKMELER = [
  { durum: ONAY_DURUMU.BEKLIYOR, ad: 'Bekleyen' },
  { durum: ONAY_DURUMU.ONAYLANDI, ad: 'Onaylı' },
  { durum: ONAY_DURUMU.REDDEDILDI, ad: 'Reddedilen' },
];

export default function Kampanyalar({ onDegisim }) {
  const [sekme, setSekme] = useState(ONAY_DURUMU.BEKLIYOR);
  const [kayitlar, setKayitlar] = useState([]);
  const [imlec, setImlec] = useState(null);
  const [dahaVar, setDahaVar] = useState(false);
  const [yukleniyor, setYukleniyor] = useState(true);
  const [hata, setHata] = useState('');
  const [karar, setKarar] = useState(null);
  const [onizleme, setOnizleme] = useState(null);

  const yukle = useCallback(async (durum, mevcutImlec) => {
    setHata('');
    setYukleniyor(true);
    try {
      const d = await yonetim.kampanyalar(durum, mevcutImlec);
      setKayitlar((o) => (mevcutImlec ? [...o, ...d.kayitlar] : d.kayitlar));
      setImlec(d.sonrakiImlec);
      setDahaVar(!!d.sonrakiImlec);
    } catch (e) {
      setHata(e.message);
    } finally {
      setYukleniyor(false);
    }
  }, []);

  useEffect(() => {
    setKayitlar([]);
    setImlec(null);
    yukle(sekme, null);
  }, [sekme, yukle]);

  async function kararVer(onayla, redNedeni) {
    await yonetim.kampanyaKarar(karar.id, onayla, redNedeni);
    setKarar(null);
    setKayitlar([]);
    yukle(sekme, null);
    onDegisim && onDegisim();
  }

  return (
    <div>
      <div className="page-header">
        <h1>Kampanya Onayları</h1>
        <p>Kuyumcuların oluşturduğu kampanyaları inceleyin ve karar verin</p>
      </div>

      <div className="tabs">
        {SEKMELER.map((s) => (
          <button key={s.durum} className={`tab${sekme === s.durum ? ' active' : ''}`} onClick={() => setSekme(s.durum)}>
            {s.ad}
          </button>
        ))}
      </div>

      {hata && <div className="mesaj hata">{hata}</div>}

      <div className="card tablo-kart">
        <table>
          <thead>
            <tr>
              <th>Görsel</th>
              <th>Başlık</th>
              <th>Kuyumcu</th>
              <th>Bitiş</th>
              <th>Oluşturma</th>
              <th>Durum</th>
              <th style={{ textAlign: 'right' }}>İşlem</th>
            </tr>
          </thead>
          <tbody>
            {kayitlar.map((k) => (
              <tr key={k.id}>
                <td><Gorsel url={k.resimUrl} className="logo-kucuk" alt={k.baslik} /></td>
                <td>
                  <strong>{k.baslik}</strong>
                  <div style={{ color: '#888', fontSize: 12, maxWidth: 320, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{k.detay}</div>
                </td>
                <td>{k.kuyumcuAdi}</td>
                <td>{tarih(k.bitisTarihi)}</td>
                <td>{tarihSaat(k.olusturmaUtc)}</td>
                <td><DurumEtiketi durum={k.onayDurumu} ad={k.onayDurumuAdi} /></td>
                <td style={{ textAlign: 'right', whiteSpace: 'nowrap' }}>
                  <button className="btn btn-blue btn-sm" onClick={() => setOnizleme(k)}>İncele</button>
                  {Number(k.onayDurumu) === ONAY_DURUMU.BEKLIYOR && (
                    <button className="btn btn-primary btn-sm" style={{ marginLeft: 6 }} onClick={() => setKarar(k)}>Karar ver</button>
                  )}
                </td>
              </tr>
            ))}
            {!yukleniyor && kayitlar.length === 0 && <tr><td colSpan={7} className="bos">Bu durumda kampanya bulunmuyor.</td></tr>}
            {yukleniyor && kayitlar.length === 0 && <tr><td colSpan={7} className="yukleniyor">Yükleniyor…</td></tr>}
          </tbody>
        </table>
      </div>

      {dahaVar && (
        <div style={{ textAlign: 'center' }}>
          <button className="btn btn-gray" disabled={yukleniyor} onClick={() => yukle(sekme, imlec)}>
            {yukleniyor ? 'Yükleniyor…' : 'Daha fazla yükle'}
          </button>
        </div>
      )}

      {onizleme && (
        <Modal baslik={onizleme.baslik} onKapat={() => setOnizleme(null)}>
          <Gorsel url={onizleme.resimUrl} className="gorsel-onizleme" alt={onizleme.baslik} yerTutucu="Görsel yok" />
          <p style={{ margin: '14px 0', whiteSpace: 'pre-wrap' }}>{onizleme.detay}</p>
          <div className="detay-grid">
            <div className="etiket">Kuyumcu</div><div className="deger">{onizleme.kuyumcuAdi}</div>
            <div className="etiket">Bitiş tarihi</div><div className="deger">{tarih(onizleme.bitisTarihi)}</div>
          </div>
        </Modal>
      )}

      {karar && (
        <OnayModal
          baslik={`Kampanya kararı — ${karar.baslik}`}
          aciklama="Onaylanan kampanya yayına girer. Reddederseniz gerekçe girmelisiniz."
          onKarar={kararVer}
          onKapat={() => setKarar(null)}
        />
      )}
    </div>
  );
}
